<template>
    <div>
        <div class="d-flex flex-row-reverse">
            <button class="btn btn-outline-success"
                :disabled="!permissions.find(e => e.permission_name == 'Create Coupons')"
                @click.prevent="addNewCoupon">Add Coupon</button>
        </div>
        <div class="card my-3 p-3 shadow-sm"
            v-if="add_or_edit_coupon && (permissions.find(e => e.permission_name == 'Create Coupons') || permissions.find(e => e.permission_name == 'Edit Coupons'))">
            <div class="text-center mb-3">
                <h3 class="mb-0">{{ edit_id ? 'Edit Coupon' : 'Add Coupon' }}</h3>
            </div>
            <div class="row">
                <div class="col-12">
                    <h6 class="text-uppercase text-muted border-bottom pb-2 mb-3">
                        <i class="fa fa-tag mr-2"></i>Coupon Details
                    </h6>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Coupon Text <span class="text-danger">*</span></label>
                    <input type="text" v-model="add_edit_coupon_template.coupon" class="form-control"
                        placeholder="e.g. SUMMER20" required>
                    <small class="form-text text-muted">Code customers will enter at checkout.</small>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Coupon Description <span class="text-danger">*</span></label>
                    <textarea v-model="add_edit_coupon_template.coupon_description" class="form-control" rows="1"
                        placeholder="Short description of this offer" required></textarea>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Select Categories</label>
                    <MssSelect multiple type="select" v-model="selected_category" :options="category_list"
                        label="category_name" placeholder="Category"></MssSelect>
                    <small class="form-text text-muted">Leave empty to apply the coupon to all products.</small>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Status</label>
                    <MssInput type="switch" v-model="add_edit_coupon_template.status"
                        :placeholder="add_edit_coupon_template.status ? 'Active' : 'Inactive'"></MssInput>
                </div>

                <div class="col-12">
                    <h6 class="text-uppercase text-muted border-bottom pb-2 my-3">
                        <i class="fa fa-percent mr-2"></i>Discount Settings
                    </h6>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Discount Percentage (%) <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input type="number" v-model.number="add_edit_coupon_template.discount_percentage"
                            class="form-control" min="0" max="100" step="1" placeholder="e.g. 20" required>
                        <div class="input-group-append"><span class="input-group-text">%</span></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Max Discount (₹) <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">₹</span></div>
                        <input type="number" v-model.number="add_edit_coupon_template.max_discount" class="form-control"
                            min="0" step="0.01" placeholder="e.g. 100" required>
                    </div>
                    <small class="form-text text-muted">Maximum discount amount that can be applied.</small>
                </div>
                <div class="col-12" v-if="discount_preview">
                    <div class="py-2 mb-0" style="background-color: #ddfff4; border: 1px solid #0a7a4f; color: #0a7a4f; border-radius: .25rem;">
                        <i class="fa fa-info-circle mr-1"></i>
                        Customers get <strong>{{ add_edit_coupon_template.discount_percentage }}%</strong> off, up to
                        <strong>₹{{ add_edit_coupon_template.max_discount }}</strong>.
                    </div>
                </div>

                <div class="col-12">
                    <h6 class="text-uppercase text-muted border-bottom pb-2 my-3">
                        <i class="fa fa-sliders mr-2"></i>Usage &amp; Eligibility
                    </h6>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Max Usage (Times) <span class="text-danger">*</span></label>
                    <input type="number" v-model.number="add_edit_coupon_template.max_usage" class="form-control" min="1"
                        step="1" placeholder="e.g. 100" required>
                    <small class="form-text text-muted">Total number of times the coupon can be used.</small>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Min Order Price (₹) <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">₹</span></div>
                        <input type="number" v-model.number="add_edit_coupon_template.minimum_price"
                            class="form-control" min="0" step="0.01" placeholder="e.g. 500" required>
                    </div>
                    <small class="form-text text-muted">Minimum cart value required for the coupon to apply.</small>
                </div>
                <div class="col-md-6">
                    <label class="font-weight-bold">Used By Date <span class="text-danger">*</span></label>
                    <input type="date" v-model="add_edit_coupon_template.use_by_date" class="form-control" required>
                    <small class="form-text text-muted">Coupon expires after this date.</small>
                </div>

                <div class="col-12 text-center mt-4">
                    <button :class="edit_id ? 'btn btn-warning' : 'btn btn-success'" :disabled="saving"
                        @click.prevent="add_coupon">
                        <i v-if="saving" class="fa fa-spinner fa-spin pr-2"></i>
                        <i v-else-if="edit_id" class="fa fa-pencil pr-2"></i>
                        <i v-else class="fa fa-plus pr-2"></i>
                        <span>{{ saving ? 'SAVING...' : (edit_id ? 'EDIT' : 'ADD') }}</span>
                    </button>
                    <button class="btn btn-danger ml-2" :disabled="saving" @click.prevent="closeAddCoupon"><i
                            class="fa fa-times pr-2"></i>CLOSE</button>
                </div>
            </div>
        </div>
        <div class="card my-3 p-3 position-relative" style="max-height: 65vh; overflow: auto;">
            <div
                :style="!permissions.find(e => e.permission_name == 'View Coupons') ? 'filter: blur(4px); pointer-events: none;' : ''">
                <table class="table table-striped mb-0">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th class="text-center" v-for="(heading, index) in table_heading" :key="index">
                                {{ heading }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(coupon, ind) in coupons_list" :key="ind">
                            <td class="text-center">{{ ind + 1 }}</td>
                            <td class="text-center">{{ coupon.coupon }}</td>
                            <td class="text-center">
                                <template v-if="coupon.categories.length > 0">
                                    <span class="badge badge-pill"
                                        style="background-color: #ddfff4; color: #0a7a4f; border: 1px solid #0a7a4f;"
                                        v-for="cal in coupon.categories">{{ cal.category_name }}</span>
                                </template>
                                <span class="badge badge-pill"
                                    style="background-color: #ddfff4; color: #0a7a4f; border: 1px solid #0a7a4f;"
                                    v-else>All Products</span>
                            </td>
                            <td class="text-center">₹{{ coupon.max_discount }} <i class="fa fa-money text-success"></i>
                            </td>
                            <td class="text-center">{{ coupon.discount_percentage }} <i
                                    class="fa fa-percent text-warning"></i> </td>
                            <td class="text-center">{{ coupon.max_usage }} <i class="fa fa-user text-primary"></i> </td>
                            <td class="text-center">{{ coupon.use_by_date }} <i
                                    class="fa fa-calendar-check-o text-primary"></i></td>
                            <td class="text-center">₹{{ coupon.minimum_price }} <i class="fa fa-money text-success"></i>
                            </td>
                            <!-- <td  class="text-center">
                                <MssInput type="switch" @input="changeCouponStatus(coupon.id, coupon.status)" v-model="coupon.status" :placeholder="coupon.status ? 'Active' : 'Inactive'"></MssInput>
                            </td> -->
                            <td class="text-center" style="width: 100px;">
                                <button class="btn btn-warning btn-sm mr-1"
                                    :disabled="!permissions.find(e => e.permission_name == 'Edit Coupons')"
                                    @click.prevent="edit_coupon(coupon.id)"><i class="fa fa-pencil"></i></button>
                                <button class="btn btn-danger btn-sm"
                                    :disabled="!permissions.find(e => e.permission_name == 'Delete Coupons')"
                                    @click.prevent="deleteCoupon(coupon.id)"><i class="fa fa-trash"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="position-absolute"
                style="top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1000;"
                v-if="!permissions.find(e => e.permission_name == 'View Coupons')">
                <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
                    permission.</span>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            add_or_edit_coupon: false,
            add_edit_coupon_template: {
                id: null,
                coupon: null,
                coupon_description: null,
                max_discount: null,
                discount_percentage: null,
                max_usage: null,
                use_by_date: null,
                minimum_price: null,
                status: 1
            },
            edit_id: null,
            delete_id: null,
            saving: false,
            coupons_list: [],
            table_heading: [
                "Coupon",
                // "coupon_description",
                "Products",
                "Max Discount",
                "Percentage",
                "Max Usage",
                "Use By Date",
                "Minimum Price",
                // "status",
                "Action"
            ],
            debounce_timer: null,
            permissions: null,
            category_list: [],
            selected_category: []
        }
    },
    async mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'COUPONS' && e.has_permission == true)
        }
        await this.fetchCategory()
        await this.fetch_coupons()
    },
    computed: {
        discount_preview() {
            const pct = this.add_edit_coupon_template.discount_percentage
            const max = this.add_edit_coupon_template.max_discount
            return (pct !== '' && pct !== null && pct !== undefined && pct > 0) &&
                (max !== '' && max !== null && max !== undefined && max > 0)
        }
    },
    methods: {
        async fetchCategory() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetchAllCategories',
                }
            })
            this.category_list = response.data.data
        },
        async deleteCoupon(id) {
            const ev = this
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                        data: {
                            type: 'delete_coupon',
                            id
                        }
                    }).then(function (response) {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 3000,
                            icon: response.data.status,
                            timerProgressBar: true,
                            title: response.data.msg
                        })
                        ev.fetch_coupons()
                    })
                }
            })
        },
        async changeCouponStatus(id, status) {
            clearTimeout(this.debounce_timer)
            this.debounce_timer = setTimeout(async () => {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        type: 'update_coupon_status',
                        id,
                        status: status
                    }
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
            }, 300);
        },
        async edit_coupon(id) {
            this.edit_id = id
            await this.fetchCategory()
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetch_coupons',
                    id
                }
            })
            this.add_edit_coupon_template = {
                id: id,
                coupon: response.data.coupons[0].coupon,
                coupon_description: response.data.coupons[0].coupon_description,
                max_discount: response.data.coupons[0].max_discount,
                discount_percentage: response.data.coupons[0].discount_percentage,
                max_usage: response.data.coupons[0].max_usage,
                use_by_date: response.data.coupons[0].use_by_date,
                minimum_price: response.data.coupons[0].minimum_price,
                status: response.data.coupons[0].status != undefined ? response.data.coupons[0].status : 1
            }
            this.selected_category = this.category_list.filter(e => response.data.coupons[0].categories.includes(e.id))
            this.add_or_edit_coupon = true
        },
        closeAddCoupon() {
            this.resetTemplate()
        },
        resetTemplate() {
            this.add_edit_coupon_template = {
                id: null,
                coupon: null,
                coupon_description: null,
                max_discount: null,
                discount_percentage: null,
                max_usage: null,
                use_by_date: null,
                minimum_price: null,
                status: 1
            }
            this.selected_category = []
            this.edit_id = null
            this.add_or_edit_coupon = false
            this.fetch_coupons()
        },
        addNewCoupon() {
            this.resetTemplate()
            this.add_or_edit_coupon = true
        },
        async fetch_coupons() {
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: {
                    type: 'fetch_coupons'
                }
            })
            const ev = this
            this.coupons_list = response.data.coupons.sort((a, b) => b.id - a.id).map(e => {
                return {
                    ...e,
                    categories: e.categories.map(el => ev.category_list.find(it => it.id == el))
                }
            })
        },
        async add_coupon() {
            let checked = false
            const labels = {
                coupon: 'Coupon Text',
                coupon_description: 'Coupon Description',
                max_discount: 'Max Discount',
                discount_percentage: 'Discount Percentage',
                max_usage: 'Max Usage',
                use_by_date: 'Used By Date',
                minimum_price: 'Min Order Price'
            }
            Object.keys(this.add_edit_coupon_template).forEach(e => {
                if (!this.add_edit_coupon_template[e] && e != 'id' && e != 'status' && !checked) {
                    this.$toasted.global.error({
                        message: `${labels[e] || e} is a required field.`
                    })
                    checked = true
                }
            })
            if (checked) {
                return
            }
            this.saving = true
            let payload_data = {}
            if (!this.edit_id) {
                payload_data = {
                    type: 'create_coupon',
                    coupon_text: this.add_edit_coupon_template.coupon,
                    coupon_description: this.add_edit_coupon_template.coupon_description,
                    max_discount: this.add_edit_coupon_template.max_discount,
                    discount_percentage: this.add_edit_coupon_template.discount_percentage,
                    max_usage: this.add_edit_coupon_template.max_usage,
                    use_by_date: this.add_edit_coupon_template.use_by_date,
                    minimum_price: this.add_edit_coupon_template.minimum_price,
                    status: this.add_edit_coupon_template.status ? 1 : 0,
                    categories: this.selected_category.map(e => e.id)
                }
            } else {
                payload_data = {
                    type: 'update_coupon',
                    id: this.edit_id,
                    coupon_text: this.add_edit_coupon_template.coupon,
                    coupon_description: this.add_edit_coupon_template.coupon_description,
                    max_discount: this.add_edit_coupon_template.max_discount,
                    discount_percentage: this.add_edit_coupon_template.discount_percentage,
                    max_usage: this.add_edit_coupon_template.max_usage,
                    use_by_date: this.add_edit_coupon_template.use_by_date,
                    minimum_price: this.add_edit_coupon_template.minimum_price,
                    status: this.add_edit_coupon_template.status ? 1 : 0,
                    categories: this.selected_category.map(e => e.id)
                }
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: payload_data
            })
            console.log(response);
            this.saving = false
            this.$swal({
                toast: true,
                position: 'top-end',
                timer: 3000,
                icon: response.data.status,
                timerProgressBar: true,
                title: `${this.edit_id ? "Coupon updated successfully." : "Coupon created successfully."}`
            })
            this.resetTemplate()
        },
    }
}
</script>